import { createNotification, type GlobalConfig } from '@repo/go-ui';
import type { i18n } from 'i18next';

import { CreateTemplateForm } from '../../../shared/components/CreateTemplateForm/CreateTemplateForm';
import modalBox from '../../../shared/components/ModalBox/modalBox';
import styles from '../AlertRulesTable.module.css';
import type { AlertRule } from '../services/AlertRule.entity';
import type { AlertRulesService } from '../services/AlertRulesService';
import { AlertRulesTemplatesManager } from '../services/AlertRulesTemplatesManager';

export function openCreateTemplateModal(
  alertRulesService: AlertRulesService,
  selectedAlertRules: AlertRule[],
  configProvider: GlobalConfig,
  i18n: i18n,
) {
  return modalBox({
    configProvider,
    modalBody: (close) => (
      <div style={{ width: 440 }}>
        <div className={styles.modalTitle}>
          {i18n.t('alertsManagerWidget:alertRules.templatesDrawer.createTemplate')}
        </div>
        <CreateTemplateForm
          onSubmit={(values) => {
            alertRulesService
              .saveTemplate(alertRulesService.index, values.name, values.description, selectedAlertRules)
              .catch((e) => {
                createNotification({
                  title: 'Error',
                  text: e.name,
                  type: 'error',
                });
              });
            close('ok');
          }}
          onCancel={() => {
            close('cancel');
          }}
          labels={{
            name: 'alertsManagerWidget:alertRules.templatesDrawer.name',
            description: 'alertsManagerWidget:alertRules.templatesDrawer.description',
            errorTextMaxLength: 'alertsManagerWidget:alertRules.templatesDrawer.errorTextMaxLength',
            submitButtonMessage: 'alertsManagerWidget:alertRules.templatesDrawer.submitButtonMessage',
            cancelButtonMessage: 'alertsManagerWidget:alertRules.templatesDrawer.cancelButtonMessage',
          }}
          i18n={i18n}
          maxNameLength={AlertRulesTemplatesManager.MAX_TEMPLATE_NAME_LENGTH}
          maxDescriptionLength={AlertRulesTemplatesManager.MAX_TEMPLATE_DESCRIPTION_LENGTH}
        />
      </div>
    ),
  });
}
